"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _string = require("@insided/deprecated-preact-components/utils/string");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Modal = require("@insided/shared/uikit/Modal");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AddTopicCardModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddTopicCardModal, _Component);

  var _super = _createSuper(AddTopicCardModal);

  function AddTopicCardModal() {
    var _this;

    (0, _classCallCheck2.default)(this, AddTopicCardModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "urlInputRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      topic: null,
      error: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      var _this$urlInputRef;

      return (_this$urlInputRef = _this.urlInputRef) === null || _this$urlInputRef === void 0 ? void 0 : _this$urlInputRef.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUrlInput", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(event) {
        var topicUrl, response, _response$data, topictitle, content, featuredimage, contenttype, author, url, startDate, type;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // @ts-expect-error
                topicUrl = event.target.value;
                _context.next = 4;
                return _axios.default.get("/topic/checkurl?checkurl=".concat(topicUrl));

              case 4:
                response = _context.sent;
                _response$data = response.data, topictitle = _response$data.topictitle, content = _response$data.content, featuredimage = _response$data.featuredimage, contenttype = _response$data.contenttype, author = _response$data.author, url = _response$data.url, startDate = _response$data.startDate, type = _response$data.type;

                _this.setState({
                  topic: {
                    title: topictitle,
                    content: content,
                    featuredImage: featuredimage,
                    contentType: contenttype,
                    author: author,
                    url: url,
                    startDate: startDate,
                    type: type
                  },
                  error: null
                });

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                _this.setState({
                  topic: null,
                  error: "Sorry, there's no topic matching that URL"
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAdd", function () {
      var topic = _this.state.topic;

      if (!topic) {
        return;
      }

      _this.props.onAdd(topic);
    });
    return _this;
  }

  (0, _createClass2.default)(AddTopicCardModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isOpen = _this$props.isOpen,
          _onClose = _this$props.onClose;
      var _this$state = this.state,
          topic = _this$state.topic,
          error = _this$state.error;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: isOpen,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Topic card",
        onClose: function onClose() {
          return _onClose();
        }
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
        className: "add-topic-card-modal"
      }, (0, _preact.h)(_InputGroup.default, {
        ref: function ref(_ref2) {
          var _base$querySelector;

          // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
          _this2.urlInputRef = (_base$querySelector = _ref2 === null || _ref2 === void 0 ? void 0 : _ref2.base.querySelector('input')) !== null && _base$querySelector !== void 0 ? _base$querySelector : null;
        },
        newStyle: true,
        placeholder: "Embed a community topic by pasting topic URL",
        onKeyUp: this.onUrlInput
      }), error && (0, _preact.h)("div", {
        className: "no-results"
      }, error), topic && (0, _preact.h)(TopicResult, {
        topic: topic,
        onAdd: this.onAdd
      }))));
    }
  }]);
  return AddTopicCardModal;
}(_preact.Component);

var TopicResult = function TopicResult(_ref3) {
  var topic = _ref3.topic,
      onAdd = _ref3.onAdd;
  var title = topic.title,
      contentType = topic.contentType,
      _topic$author = topic.author,
      id = _topic$author.id,
      username = _topic$author.username,
      avatar = _topic$author.avatar;
  return (0, _preact.h)("div", {
    className: "topic-result"
  }, (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "title"
  }, title), (0, _preact.h)("div", {
    className: "meta"
  }, (0, _string.capitalize)(contentType), " by", (0, _preact.h)(_UserAvatar.default, {
    disableLink: true,
    style: {
      width: '16px',
      height: '16px'
    },
    user: {
      id: id,
      name: username,
      avatar: avatar
    }
  }), (0, _preact.h)("span", null, username))), (0, _preact.h)(_Button.default, {
    title: "Add",
    onClick: function onClick() {
      return onAdd();
    }
  }));
};

var _default = AddTopicCardModal;
exports.default = _default;